/*jshint esversion: 6 */

import get from 'lodash/get';
import isNull from 'lodash/isNull';
import * as quizSelectors from "../selectors/quizSelectors";
import {quizTitle} from "../selectors/quizSelectors";
import {featuredImage} from "../selectors/quizSelectors";
import {getPointsForCurrentQuiz} from "../selectors/quizSelectors";
import {availablePointsForQuiz} from "../selectors/quizSelectors";

export const TYPE_OPTIONS = 'options';
export const TYPE_FREETEXT = 'freetext';

export const getPointsForQuestion = (question, answer) => {
    return isCorrectAnswer(question, answer) ? 1 : 0;
};

const isCorrectAnswer = (question, answer) => {
    const correct = get(question, '[question-meta].correct');
    return correct ? correct === answer : 0;
};

export const isLastQuestion = (questions, questionsData) => {
    return questions.length === questionsData.length;
}

export const quizId = props => {
    return get(props, 'quiz.post.id');
}

export const getQuestionType = question => {
    return isNull( get( question, 'question-meta.options' ) ) ? TYPE_FREETEXT : TYPE_OPTIONS;
};

export const hasPreviouslyTakenQuiz = props => {
    return get(props, `result.${quizId(props)}`);
};

export const getSharedUrlForResult = (result, quiz) => {
    let shareObject = getSharedResultObject(result, quiz);
    return `${window.location.protocol}//${window.location.host}/golden-club/${shareObject}`;   // Todo: get that slug from somewhere else!!
}

/**
 * Returns an encoded string containing result meta data
 * @param {result} The firebase result store
 * @param {quiz} The quiz store
 * @returns {String}
 */
export const getSharedResultObject = (result, quiz) => {

    const stripRegex = /(<([^>]+)>)/ig;

    let points = quizSelectors.getPointsForCurrentQuiz(result, quiz);
    let content = quiz.post.content.rendered.replace(stripRegex, '');
    let title = quizSelectors.quizTitle(quiz);
    let featuredImageObj = quizSelectors.featuredImage(quiz);
    let featureImage = featuredImageObj[0];
    let width = featuredImageObj[1];
    let height = featuredImageObj[2];

    let possiblePoints = quizSelectors.availablePointsForQuiz(quiz);
    let shareObject = unescape(encodeURIComponent(JSON.stringify({points, content, featureImage, width, height, title, possiblePoints})));

    return btoa(shareObject);
}

/**
 * Get the title to use for sharing the result of the current quiz
 * @param {result} The result screen
 * @param {quiz} The quiz screen
 * @returns {string}
 */
export const getSharedTitle = (result, quiz) =>  {

    let points = quizSelectors.getPointsForCurrentQuiz(result, quiz);
    let possiblePoints = quizSelectors.availablePointsForQuiz(quiz);
    let quizTitle = quizSelectors.quizTitle(quiz);

    return `I got  ${points} of ${possiblePoints} on the official Abba quiz: ${quizTitle}`; // TODO: Could a es6 template string be stored as JSON???
}